import Vue from 'vue'

Vue.directive('pseudo-modal', {

	bind(el, binding) {

		Pseudomodal.add(binding.value.replace(/'/g, ""), el);

		Pseudomodal.hide(binding.value.replace(/'/g, ""));

	},

	unbind(el, binding) {

		// 2024.09.27 при переключении между вкладками playables banners endcards перестаёт открываться download выпадающий список ('download-dropdown')
		// на вкладке endcards, так как сначала идёт добавление нового элемента в this.elements, а потом удаление, что неправильно.
		// На других вкладках сначала удаление, а потом добавление.
		// Отмена удаления решает проблему - работает всё как надо.
		// Pseudomodal.remove(binding.value.replace(/'/g, ""));

	}

});

Vue.directive('pseudo-modal-show', {

	bind(el, binding) {

		el.addEventListener(Broadcast.isTouchDevice ? 'touchend' : 'mouseup', () => {

			Pseudomodal.toggle(binding.value.replace(/'/g, ""));
			Pseudomodal.eventElements.push(binding.value.replace(/'/g, ""));

		});

	}

});

Vue.directive('pseudo-modal-name', {

	bind(el, binding) {

		el.addEventListener(Broadcast.isTouchDevice ? 'touchend' : 'mouseup', () => {

			Pseudomodal.eventElements.push(binding.value.replace(/'/g, ""));

		});

	}

});

let Pseudomodal = {

	init() {

		//Все pseudomodal элементы
		this.elements = {};

		//Pseudomodal элементы через которые прошёл клик (заполняются по мере распространения клик события)
		this.eventElements = [];

		Broadcast.on("Pseudo Modal Show", Pseudomodal.show, this);
		Broadcast.on("Pseudo Modal Hide", Pseudomodal.hide, this);
		Broadcast.on("Document Press Up", Pseudomodal.processHide, this);
		Broadcast.on("<27>", Pseudomodal.processHide, this);

	},

	add(name, el) {

		//Положим элемент в список всех pseudomodal элементов
		if (!this.elements[name]) this.elements[name] = {};
		this.elements[name].el = el;

		//Когда клик проходит через pseudomodal элемент
		el.addEventListener(Broadcast.isTouchDevice ? 'touchend' : 'mouseup', () => {

			//Кладём его в массив массив элементов через которые прошёл клик
			this.eventElements.push(name);

		});

	},

	remove(name) {

		//Удалим элемент из списка всех pseudomodal элементов
		delete this.elements[name];

	},

	//В момент завершения клика
	processHide() {

		//Проходим по всем pseudomodal элементам
		Object.keys(this.elements).forEach((name) => {

			//Если клик не проходил через этот элемент
			if (!this.eventElements.includes(name)) {

				this.hide(name);

			}

		});

		Broadcast.call('Pseudo Modal Process Hide', [this.eventElements]);

		//Обнуляем массив элементов по которым прошёл клик в коце клика
		this.eventElements = [];

	},

	show(name) {

		if (!this.elements[name] || !this.elements[name].el) return;

		let el = this.elements[name].el;

		//Если элемент не показан
		if (!this.isShowed(name)) {

			//Показываем этот элемент
			el.style.display = '';

			Broadcast.call("Pseudo Modal Showed", [name]);
			Broadcast.call("Pseudo Modal Showed " + name);

		}

	},

	hide(name) {

		if (!this.elements[name] || !this.elements[name].el) {

			Broadcast.call("Pseudo Modal Hided", [name]);
			Broadcast.call("Pseudo Modal Hided " + name);

			return;

		}

		let el = this.elements[name].el;

		//Если элемент показан
		if (this.isShowed(name)) {

			//Скрываем этот элемент
			el.style.display = 'none';

			Broadcast.call("Pseudo Modal Hided", [name]);
			Broadcast.call("Pseudo Modal Hided " + name);

		}

	},

	toggle(name) {

		if (this.isShowed(name)) this.hide(name);
		else this.show(name);

	},

	isShowed(name) {

		if (!this.elements[name] || !this.elements[name].el) return false;

		let el = this.elements[name].el;

		return el.style.display !== 'none';

	}

};

Pseudomodal.init();

